import {useEffect, useState, Fragment, useContext} from "react";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import {
    Button,
    ButtonGroup,
    Checkbox,
    Container,
    Divider, FormControl, FormControlLabel, FormGroup,
    IconButton, InputLabel,
    MenuItem,
    Select, TextField,
    Tooltip,
    Typography
} from "@mui/material";
import axios from "axios";

import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import { useAuthState } from 'react-firebase-hooks/auth';
import LoadingBackdrop from "../../components/LoadingBackdrop";
import Page from "../../components/Page";
import useSettings from "../../hooks/useSettings";
import {BASE_HOST, getAccountAPIHeader} from "../../utils/urlConst";
import {dateRangesOverlap, getParameterByName, refreshAds} from "../../utils/basicUtilities";
import SuppressionSelector from "./components/SuppressionSelector";
import QuotaModal from "./components/QuotaModal";
import TimesOfDaySelector from "./components/TimesOfDaySelector";
import Label from "../../components/Label";
import {DateRangeContext} from "./DateProvider";
import AdsGrid from "./components/AdsGrid";
import { auth } from '../../firebase';

function castToUTCWithoutChangingTime(date) {
    return new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ));
}
export default function Offer() {
    const {themeStretch} = useSettings();
    const [loading, setLoading] = useState(true);
    const [objData, setObjData] = useState({});
    const [onLoadObject, setOnLoadObject] = useState({});
    const [suppressionOptions, setSuppressionOptions] = useState([]);
    const [lists, setLists] = useState([]);
    const dateSelectorState = useContext(DateRangeContext);
    const [user] = useAuthState(auth);



    useEffect(() => {
        user.getIdToken().then((idToken) => {
        axios.get(`${BASE_HOST}/api/basic/ui-options`, getAccountAPIHeader(idToken))
            .then(res => {
                console.log("Offer Loaded");
                console.log(res.data);
                setSuppressionOptions(res.data.suppressionLists);

                // UI Bugs if options aren't loaded first...
                axios.get(`${BASE_HOST}/api/basic/offers?id=${getParameterByName("id")}`, getAccountAPIHeader(idToken))
                  .then(res => {
                      console.log("Offer Loaded");
                      console.log(res.data);
                      setLoading(false);

                      if (res.data.quotas) {
                          for (let i = 0; i < res.data.quotas.length; i += 1) {
                              res.data.quotas[i].startDate = new Date(res.data.quotas[i].startDate);
                              res.data.quotas[i].endDate = new Date(res.data.quotas[i].endDate);
                          }
                      }

                      if (res.data.schedule) {
                          for (let i = 0; i < res.data.schedule.length; i += 1) {
                              res.data.schedule[i].startDate = new Date(res.data.schedule[i].startDate);
                              res.data.schedule[i].endDate = new Date(res.data.schedule[i].endDate);
                          }
                      }

                      if (!res.data.fromNames) {
                          res.data.fromNames = [];
                      }

                      refreshAds(setLists, dateSelectorState.dates[0], dateSelectorState.dates[1], getParameterByName("id"), idToken)
                      setObjData(res.data);
                      setOnLoadObject(res.data); // For Tracking Changes
                  })
            })
            })
    }, [])

    const title = `${objData.name} ${objData.hasOfferId ? `( ID: ${objData.hasOfferId})` : ""}`
    // Schedule: {objData.fulfillmentMethod}
    // Quotas: {objData.fulfillmentMethod}

    let statusColor = "error";
    if (objData.status === "active") {
        statusColor = "success"
    } else if (objData.status === "closed") {
        statusColor = "warnining"
    }

    function validateObject() {
        // pass
        //  _.isEqual
        if (objData.quotas && dateRangesOverlap(objData.quotas)) {
            return "Quota Date Ranges Overlap";
        }

        if (objData.schedules && dateRangesOverlap(objData.schedules)) {
            return "Schedule Serving Times Overlap";
        }

        if (objData.suppressions && objData.suppressions.indexOf("") !== -1) {
            return "Suppression List Has An Empty Entry";
        }

        return true;
    }

    function serializeObject(objIn) {
        const dataOut = {
            "id": objIn.id,
            "quotas": [],
            "fromNames":  objIn.fromNames,
            "impressionBias": objIn.impressionBias ? objIn.impressionBias : 1.0,
            "fulfillmentMethod": objIn.fulfillmentMethod,
            "suppressionList": [], // list of suppression id's
            "schedule": [],
            "onlyOneClick": false
        }

        if (objIn.quotas) {
            for (let i = 0; i < objIn.quotas.length; i += 1) {
                const quotaObject = objIn.quotas[i];
                const storeObj = {
                    startDate: quotaObject.startDate,
                    endDate: quotaObject.endDate,
                };
                console.log("Quota Parsing...");
                // eslint-disable-next-line no-restricted-syntax
                for (const z of ["click"]) {

                    if (quotaObject[`${z}MinQuota`] !== "any" && !Number.isNaN(parseInt(quotaObject[`${z}MinQuota`], 10))) {
                        storeObj[`${z}MinQuota`] = parseInt(quotaObject[`${z}MinQuota`], 10)

                        if (quotaObject[`${z}MinQuotaBias`] !== "any" && !Number.isNaN(parseFloat(quotaObject[`${z}MinQuotaBias`]))) {
                            storeObj[`${z}MinQuotaBias`] = parseFloat(quotaObject[`${z}MinQuotaBias`])
                        } else {
                            storeObj[`${z}MinQuotaBias`] = 0.0;
                        }
                    } else {
                        storeObj[`${z}MinQuota`] = "any";
                        storeObj[`${z}MinQuotaBias`] = 0.0;
                    }

                    if (quotaObject[`${z}MaxQuota`] !== "any" && !Number.isNaN(parseInt(quotaObject[`${z}MaxQuota`], 10))) {
                        storeObj[`${z}MaxQuota`] = parseInt(quotaObject[`${z}MaxQuota`], 10);
                    } else {
                        storeObj[`${z}MaxQuota`] = "any";
                    }
                }
                dataOut.quotas.push(storeObj);
            }
        }

        if (objIn.suppressionList) {
            dataOut.suppressionList = objIn.suppressionList
        }

        if (objIn.schedule) {
            for (let i = 0; i < objIn.schedule.length; i += 1) {
                console.log("Look! Listen!");
                console.log("SCHEDULE:");
                console.log(objIn.schedule[i]);
                dataOut.schedule.push({
                    startDate: castToUTCWithoutChangingTime(objIn.schedule[i].startDate).toISOString(),
                    endDate: castToUTCWithoutChangingTime(objIn.schedule[i].endDate).toISOString(),
                    days: objIn.schedule[i].days,
                });
            }
        }
        if(objIn.onlyOneClick){
            dataOut.onlyOneClick=objIn.onlyOneClick;
        }

        return dataOut;
    }

    function isChange() {
        const v1 = JSON.stringify(serializeObject(objData));
        const v2 = JSON.stringify(serializeObject(onLoadObject));
        return v1 !== v2;
    }

    const friendlyFromNames = [];
    if(objData.fromNames){
        for(let i=0;i<objData.fromNames.length; i+=1) {
            friendlyFromNames.push(
                <span style={{"display": "flex"}} id={`creative${i}`}>
                     <TextField
                         freesolo={"true"}
                         openonfocus={"true"}
                         style={{"width": "90%"}}
                         value={`${objData.fromNames[i]}`}
                         error={(objData.fromNames[i] || '').length < 2}
                         color={(objData.fromNames[i] || '').length >= 3 ? 'success' : 'error'}
                         placeholder={"Enter Name For Ad"}
                         onChange={(v) => {
                             const cre = [...objData.fromNames];
                             cre[i]=v.target.value
                             setObjData({...objData, "fromNames": cre})
                         }}
                     />

                    <IconButton aria-label="delete" onClick={() => {
                        const cre = [...objData.fromNames];
                        cre.splice(i, 1)
                        setObjData({...objData, "fromNames": cre})
                    }}>
                      <DeleteIcon/>
                    </IconButton>
               </span>
            )
        }
    }

    console.log(objData);
    return <Page title="Edit: Offer">
        {loading ? <LoadingBackdrop/> :
            <Container maxWidth={themeStretch ? false : 'xl'}>
                <Typography variant={"h2"}>
                    {title}
                </Typography>
                <Typography variant={"h3"} style={{"marginLeft": "1.5em"}}>
                    [{objData.advertiser}]
                </Typography>
                <br/>
                <Typography variant={"paragraph"}>
                    Status: <Label color={statusColor} variant="filled">{objData.status}</Label>
                </Typography>
                <br/>
                <Typography variant={"paragraph"}>
                    Offer Type: <Label color="success" variant="filled">{objData.type} </Label>
                    <Tooltip title={
                        <Typography>
                            <b><u>CPA</u></b> - cost per aquistion. Payout is based on sale traced to an ad
                            click <br/><br/>
                            <b><u>CPC</u></b> - cost per click. Payout is based on each unique click recorded <br/><br/>
                            <b><u>CTO</u></b> - click to opt-in. Payout is based on each unique lead shared <br/><br/>
                        </Typography>
                    }>
                        <IconButton>
                            <InfoIcon/>
                        </IconButton>
                    </Tooltip>
                </Typography>


                <br/><br/>
                <Typography align="left" style={{"marginTop": "auto", "marginBottom": "auto"}}>
                    Impression Bias
                </Typography>

                <TextField
                    id={`impressionBias`}
                    label={`impressionBias`}
                    value={objData.impressionBias ? objData.impressionBias : 1.0}
                    inputProps={{inputMode: 'numeric', pattern: '[0-9]*'}}
                    onChange={(v) => {
                        const z = {...objData, impressionBias: v.target.value};
                        setObjData(z)
                    }}
                />
                <br/> <br/><br/>
                <InputLabel id="fulfillment-method-label">Fulfillment Method</InputLabel>
                <Select
                    labelId="fulfillment-method-label"
                    id="fulfillment-method"
                    value={objData.fulfillmentMethod ? objData.fulfillmentMethod : ''}
                    label="Fulfillment Method"
                    onChange={(e) => {
                        const z = {...objData, fulfillmentMethod: e.target.value};
                        setObjData(z)
                    }}
                >
                    <MenuItem value={"open"}>Open</MenuItem>
                    <MenuItem value={"fixed"}>Fixed</MenuItem>
                    <MenuItem value={"off"}>Off</MenuItem>
                </Select>
                <Tooltip style={{"marginTop": ".25em"}} title={
                    <Typography>
                        <b><u>Open</u></b> - means that the ad-server has no limits on how often it can serve the
                        ads associated with this offer. <br/><br/>
                        <b><u>Fixed</u></b> - means the ad server will only fulfill specified quotas. If no quotas
                        exist then ads associated with the offer won't serve. <br/><br/>
                        <b><u>Off</u></b> - means the ad server will not serve any ads associated with the
                        offer. <br/><br/>
                    </Typography>
                }>
                    <IconButton>
                        <InfoIcon/>
                    </IconButton>
                </Tooltip>
                <br/><br/>
                <FormGroup>
                    <FormControlLabel control={<Checkbox checked={objData.onlyOneClick === true}
                                                         onChange={(e) => {
                                                             setObjData({
                                                                 ...objData,
                                                                 "onlyOneClick": !objData.onlyOneClick
                                                             });
                                                         }}/>} label="Allow Only 1 Promo Click Per Email Address"/>
                </FormGroup>
                <br/><br/>
                <QuotaModal quotas={objData.quotas} setQuotas={(d) => setObjData({...objData, quotas: d})}/>
                <br/><br/>
                <TimesOfDaySelector schedules={objData.schedule}
                                    setSchedules={(d) => setObjData({...objData, schedule: d})}/>
                <br/><br/>
                <SuppressionSelector suppressionOptions={suppressionOptions} suppressions={objData.suppressionList}
                                     setSuppressions={(lst) => setObjData({...objData, suppressionList: lst})}/>
                <br/><br/>
                <Typography align="left" variant={"h5"}>
                    Friendly From Names&nbsp;&nbsp;&nbsp;
                    <Tooltip style={{"marginTop": ".25em"}} title={
                        <Typography>
                            Friendly From Set an Offer Level is overridden by creative level friendly from's.<br/>
                            Supported Macros {"\"{{LIST_NAME}}\""}. Macro's must be spelled exactly as shown without quotes
                        </Typography>
                    }>
                        <IconButton>
                            <InfoIcon/>
                        </IconButton>
                    </Tooltip>

                    <IconButton aria-label="create" onClick={() => {
                        setObjData({...objData, "fromNames": ["", ...objData.fromNames]})
                        // props.setSuppressions([...suppressions, ""])
                    }}>
                        <AddCircleIcon color={"success"}/>
                    </IconButton>
                </Typography>
                <FormControl fullWidth sx={{m: 1}}>
                    {friendlyFromNames}
                </FormControl>


                <br/>
                <br/>
                {isChange() && <ButtonGroup disableElevation variant="contained" style={{"width": "25%"}}>
                    <Button size="Large" align="right" variant="contained" color="success" onClick={() => {
                        user.getIdToken().then((idToken) => {
                            const header = getAccountAPIHeader(idToken);
                            const readyObj = serializeObject(objData);
                            axios.put(`${BASE_HOST}/api/basic/offers`, readyObj, header)
                              .then(() => window.location.reload());
                        })
                    }} style={{"width": "100%"}} disabled={validateObject() !== true}>
                        Save
                    </Button>
                </ButtonGroup>}
                <br/>
                <br/>
                <br/>
                <Typography>
                    Table Of Ads Attached To Offer
                </Typography>
                <AdsGrid data={lists}
                         refresh={() => {
                              user.getIdToken().then((idToken) => {
                                 refreshAds(setLists, dateSelectorState.dates[0], dateSelectorState.dates[1], getParameterByName("id"),idToken)
                              })
                            } } />
                <Divider/>

            </Container>
        }

        {/* <ErrorModal /> */}
    </Page>
}
